import BaseAvatar from './BaseAvatar.vue';
import AvatarUpload from './AvatarUpload.vue';

export { BaseAvatar, AvatarUpload };
